// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YimDz","top":"styles_top__2uBG-"};